export default __webpack_public_path__ + "static/media/baton_team_3.c243a068.jpg";